import mixpanel from 'mixpanel-browser';

const mixpanelToken = process.env.NODE_ENV === 'production' ?
  'a1625117f098bcac4b638be1c7cc26f4' : '390a75b9b75e9ed793136e988531d8eb'

mixpanel.init(mixpanelToken, {
  ignore_dnt: true, // ignore browser do not track requests
  // debug: true // debug mode
});

let actions = {
  identify: (id) => {
    mixpanel.identify(id);
  },
  alias: (id) => {
    mixpanel.alias(id);
  },
  track: (name, props) => {
    mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      mixpanel.people.set(props);
    },
    set_once: (props) => {
      mixpanel.people.set_once(props)
    }
  }
};

export let Mixpanel = actions;
